import { getIsProdEnv } from "@/constants";
import { getWorkerName } from "@/helpers/getWorkerName";
import type { User } from "@dndbeyond/auth/types/user";

export const getRenderedWorker = async (
  nodeEnv: string,
  env: string,
  user?: User,
) => {
  if (process.env.NODE_ENV === "development") {
    const { getDevRenderedWorker } = await import("../getDevRenderedWorker");

    return getDevRenderedWorker(nodeEnv, env, user);
  }

  return new Worker(
    `/dice/${getIsProdEnv(env) ? "mobile" : "previewer"}/renderedWorker.${process.env.NEXT_PUBLIC_RENDERED_WORKER_HASH}.js`,
    {
      name: getWorkerName("rendered", nodeEnv, env, user),
      type: "module",
    },
  );
};
